import React, { useState } from "react";
import { storage } from "../../firebaseConfig";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

const ImageUpload = () => {
  const [images, setImages] = useState<string[]>([]);

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) {
      return;
    }

    const storageRef = ref(storage, `/blogs/${Date.now()}${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Handle progress
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${progress}% done`);
      },
      (error) => {
        // Handle error
        console.error(error);
      },
      async () => {
        // Handle success
        const imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
        setImages([...images, imageUrl]);
      }
    );
  };

  return (
    <div>
      <input type="file" onChange={handleImageUpload} />
      <ul>
        {images.map((imageUrl) => (
          <li key={imageUrl}>
            <img
              src={imageUrl}
              alt="uploaded image"
              style={{ width: "80px" }}
            />
            <a href={imageUrl}>{imageUrl}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ImageUpload;
